import { AlertProps as MuiAlertProps } from '@mui/material/Alert/Alert';
import { alpha } from '@mui/system';
import { themeObject as theme, themeObject } from '../../../lib';

export interface ErrorDetails {
    details?: string[];
    error: string;
    id: string;
    message: string;
    status: number;
    timestamp: string;
}

export interface AlertProps extends MuiAlertProps {
    variant?: 'filled' | 'outlined';
    closable?: boolean;
    autoHide?: boolean;
    details?: string;
    onShowDetailsClicked?: () => void;
}

export interface AlertContextType {
    alertProps: AlertProps | null;
    showAlert: (props: AlertProps) => void;
    hideAlert: () => void;
    showErrorDetails: () => void;
}

export const styles = {
    alert: {
        zIndex: 9999, //make sure alert is possibly the top element (needs to be displayed over dialogs).
        position: 'absolute',
        left: '50%',
        top: '40px',
        transform: 'translate(-50%)',
        maxWidth: '461px',
        maxHeight: '100%',
    },
    detailsContainer: {
        display: 'flex',
        justifyContent: 'space-between',
        gap: '10px',
    },
    detailsText: {
        textDecoration: 'underline',
        cursor: 'pointer',
        ...themeObject.typography.body1,
        ...theme.typography.body.body2,
        ...themeObject.typography.body.medium,
        color: themeObject.palette.grayScale[50],
    },
    dialog: {
        zIndex: 9999,
        '& .MuiPaper-root': {
            minHeight: '160px',
            width: '462px',
            borderRadius: '10px',
            boxShadow: `
             0px 6px 30px 5px ${alpha(themeObject.palette.grayScale[700], 0.12)},
             0px 16px 24px 2px ${alpha(themeObject.palette.grayScale[700], 0.14)},
             0px 8px 10px -5px ${alpha(themeObject.palette.grayScale[700], 0.2)},
             `,
            '#dialog-title-container': {
                minHeight: '68px',
                '& .MuiDialogTitle-root': {
                    width: 'calc(100% - 68px)',
                },
            },
            '& .MuiDialogActions-root': {
                justifyContent: 'center',
                pb: 4,
            },
        },
        '& .MuiDialogContent-root': {
            padding: '8px 34.5px 12px 34.5px',
            overflowWrap: 'break-word',
        },
        '& .MuiDialogContentText-root': {
            ...themeObject.typography.body1,
            color: themeObject.palette.grayScale[800],
        },
    },
    errorDetailsContainer: {
        display: 'flex',
        flexDirection: 'column',
        gap: 2,
        width: '100%',
    },
};
